export const CALENDAR_VIEW = {
    Configure_View_Basic: 0,
    Configure_View_Default: 1,
    Configure_View_Premium: 2,
};
